<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["startDate", "endDate", "data", "errorData", "render"],
  data() {
    return {
      labels: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // Overwriting base render method with actual data.
      this.renderChart(
        {
          type: "line",
          labels: this.labels,
          datasets: [
            {
              label: "API Calls",
              backgroundColor: this.$primaryColor,
              data: this.data,
              fill: false,
              borderColor: this.$primaryColor,
              pointBackgroundColor: this.$primaryColor,
            },
            {
              label: "Errors",
              backgroundColor: "#ef4444",
              data: this.errorData,
              fill: false,
              borderColor: "#ef4444",
              pointBackgroundColor: "#ef4444",
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                id: "left-y-axis",
                type: "linear",
                ticks: {
                  beginAtZero: true,
                  stepSize: 1,
                  maxTicksLimit: 12,
                },
              },
            ],
          },
        }
      );
    },
  },
  watch: {
    render() {
      this.labels = [];
      for (
        var d = new Date(this.startDate);
        d <= this.endDate;
        d.setDate(d.getDate() + 1)
      ) {
        this.labels.push(new Date(d).toLocaleDateString());
      }
      this.init();
    },
  },
};
</script>